import "../../App.css";
import React, { lazy, useEffect } from "react";
import Sidebar from "../../Module/sidebar";
import { Navigate, Route, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { PublicationCXOPanelSidebarData } from "../../Module/PublicationCXOPanelSidebarData";
import { useDispatch } from "react-redux";
import { showSuccessSnackbar } from "../../Action/snackbarAction";

import CommonRoutes from "../Common/commonRoute";
import { Logout, setInitialState } from "../../Action/authAction";

const TransactionEdutechStudyMaterial = React.lazy(() =>
  import("../CXOPanel/transactionEdutechStudyMaterial")
);
const TransactionPublication = React.lazy(() =>
  import("./transactionPublication")
);
const TransactionDetails = React.lazy(() => import("./transactionDetails"));
const PaymentPublication = React.lazy(() => import("./paymentPublication"));
const CxoPayRoll = React.lazy(() => import("./cxoPayRoll"));
const EmployeeDetails = React.lazy(() => import("./employeeDetails"));
const PayRollCtc = React.lazy(() => import("./payRollCtc"));
const Source_Analysis = React.lazy(() => import("./sourceWiseAnalysis"));
const State_Analysis = React.lazy(() => import("./stateWiseAnalysis"));
const RevenueProjection = React.lazy(() => import("./revenueProjection"));
const CxoDashboard = React.lazy(() => import("./cxoDashboard"));
const AllExamWiseRevenue = React.lazy(() => import("./allExamWiseRevenue"));
const BoardMeetingPublication = React.lazy(() =>
  import("./boardMeetingPublication")
);
const DownloadReports = React.lazy(() => import("./downloadReports"));
const BookOrderHistory = React.lazy(() => import("./bookOrderHistory"));
const StockAnalysis = lazy(() =>
  import("../Publication/StockManagement/stockAnalysis")
);
import SellingSrcRevenueAnalysis from "./sellingSrcRevenueAnalysis";
// Movements of Meeting (same pages as the other panels)
const MovementsOfMeeting = lazy(() =>
  import("../CategoryPanel/MovementsOfMeeting/movementsOfMeeting"),
);
const EditMovementsOfMeeting = lazy(() =>
  import("../CategoryPanel/MovementsOfMeeting/editMovementsOfMeeting"),
);
const SellingSrcAnalysis = React.lazy(() => import("./sellingSrcAnalysis"));

function PubCXOPanelDashboard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loginType, role, authToken } = useSelector((state) => ({
    designation: state.Auth?.userInfo?.designation,
    loginType: state.Auth?.loginType,
    role: state?.Auth?.userInfo?.role,
    authToken: state?.Auth?.authToken,
  }));

  useEffect(() => {
    if (
      !(role === "PUBLICATIONCXO" || role === "PUBLICATION CXO") &&
      authToken
    ) {
      dispatch(setInitialState());
      navigate("/");
    }
  }, [role, dispatch, Navigate, authToken]);
  return (
    <div className="AppBox">
      <Sidebar data={PublicationCXOPanelSidebarData} />
      <div className="dashboard">
        {
          <CommonRoutes
            // loginType={loginType}
            defaultPage={<TransactionDetails />}
          >
            <Route path="/" element={<TransactionDetails />} />

            <Route path="transactionDetails" element={<TransactionDetails />} />

            <Route
              path="transactionEdutechStudyMaterial"
              element={<TransactionEdutechStudyMaterial />}
            />
            <Route
              path="transactionPublication"
              element={<TransactionPublication />}
            />
            <Route path="paymentPublication" element={<PaymentPublication />} />
            <Route path="cxoPayroll" element={<CxoPayRoll />} />
            <Route path="employeeDetails" element={<EmployeeDetails />} />
            <Route path="payRollCtc" element={<PayRollCtc />} />
            <Route path="sourceWiseAnalysis" element={<Source_Analysis />} />
            <Route path="stateWiseAnalysis" element={<State_Analysis />} />
            <Route path="RevenueProjection" element={<RevenueProjection />} />
            <Route path="cxoDashboard" element={<CxoDashboard />} />
            <Route path="allExamWiseRevenue" element={<AllExamWiseRevenue />} />
            <Route
              path="boardMeetingPublication"
              element={<BoardMeetingPublication />}
            />
            <Route path="downloadReports" element={<DownloadReports />} />
            <Route path="stockAnalysis" element={<StockAnalysis />} />
            <Route path="bookOrderHistory" element={<BookOrderHistory />} />
            <Route
              path="sellingSrcRevenueAnalysis"
              element={<SellingSrcRevenueAnalysis />}
            />
            <Route path="sellingSrcAnalysis" element={<SellingSrcAnalysis />} />
            <Route path="movementsOfMeeting" element={<MovementsOfMeeting />} />
            <Route path="editMovementsOfMeeting" element={<EditMovementsOfMeeting />} />
          </CommonRoutes>
        }
      </div>
    </div>
  );
}

export default PubCXOPanelDashboard;
